import { useState } from "react"
import { useQuery } from "react-query"

import { homeportPrompt } from "src/api/Contracts/SignContract"

const POLL_INTERVAL_MS = 2000
const DELAYED_AFTER_MS = 120000

export const PROCESSING_POLLS_BEFORE_DELAYED =
  DELAYED_AFTER_MS / POLL_INTERVAL_MS

const statusFrom = (data) => {
  if (data?.quoteCompleted) return "completed"
  if (data?.signingFailed) return "failed"
  return "processing"
}

const useSigningStatus = ({
  quoteId,
  initialStatus,
  initialReservationUrl = null,
}) => {
  const [processingPolls, setProcessingPolls] = useState(0)

  const { data, isError } = useQuery(
    ["homeportPrompt", quoteId],
    () => homeportPrompt({ quoteId }),
    {
      enabled: initialStatus === "processing",
      retry: 2,
      onSuccess: (latest) => {
        if (statusFrom(latest) === "processing") {
          setProcessingPolls((polls) => polls + 1)
        }
      },
      refetchInterval: (latest, query) =>
        query.state.status !== "error" && statusFrom(latest) === "processing"
          ? POLL_INTERVAL_MS
          : false,
    }
  )

  const status = () => {
    if (isError) return "unavailable"
    if (!data) return initialStatus

    const latestStatus = statusFrom(data)

    return latestStatus === "processing" &&
      processingPolls >= PROCESSING_POLLS_BEFORE_DELAYED
      ? "delayed"
      : latestStatus
  }

  return {
    status: status(),
    reservationUrl: data?.reservationUrl ?? initialReservationUrl,
  }
}

export default useSigningStatus
